import YouTubeLogoComponent from './youtubeLogo.component';

export const youtubeLogoModule = {
	name: 'youtubeLogoComponent',
};

export default angular
	.module(youtubeLogoModule.name, [])
	.component('youtubeLogo', new YouTubeLogoComponent()).name;
